import React, { FC } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react'
import { useResetUserDataMutation } from '../../../redux/services/skeema/users.endpoints'
import { useUserContext } from '../../../contexts/UserContext'

const DeleteUserContent: FC = () => {
  const { userInfo, captureAnalytics, signOut } = useUserContext()
  const [resetUserData] = useResetUserDataMutation()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef(null)

  const handleConfirmResetUserData = async () => {
    if (!userInfo || !userInfo.pk) {
      alert('User info not found')
      return
    }
    captureAnalytics('advanced_settings:delete_data')
    resetUserData({ id: userInfo.pk })
    onClose()
    await signOut()
  }

  return (
    <>
      <Button
        borderRadius="16px"
        height="28px"
        minWidth="80px"
        width="fit-content"
        fontWeight="500"
        fontSize="12px"
        colorScheme="red"
        onClick={onOpen}
      >
        Delete Account
      </Button>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Account
            </AlertDialogHeader>

            <AlertDialogBody>
              {"Are you sure? You can't undo this action afterwards."}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleConfirmResetUserData} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

export default DeleteUserContent
